export default __webpack_public_path__ + "static/media/model_3.30651f79.jpeg";